module.exports = __webpack_public_path__ + "static/media/hold-up.83a371dd.gif";